import { cloneDeep } from 'lodash'
import type { ColoredHighlightCount } from './types'

export const countHighlights = (
  text: string,
  originalColoredHighlights: Array<
    Pick<ColoredHighlightCount, 'regex' | 'keyword'>
  >
): Array<Pick<ColoredHighlightCount, 'regex' | 'keyword'>> => {
  const coloredHighlights = cloneDeep(originalColoredHighlights)
  const highlightCountMap = new Map<string, number>()

  if (coloredHighlights.length === 0) {
    return []
  }

  for (const { regex, keyword } of coloredHighlights) {
    const matches = text.matchAll(regex)
    highlightCountMap.set(keyword, [...matches].length)
  }

  return coloredHighlights.map(({ regex, keyword }) => ({
    regex,
    keyword,
    count: highlightCountMap.get(keyword)!,
  }))
}
